import style from "./participants.module.css";
import defaultAvatar from "../../images/196m.png";
import { TEvent } from "../../types";
import { pluralizeRu } from "../../utils/pluralize";
interface Props {
    event: TEvent
}
const mockParticipantAvatarPool = [
    "/images/0.jpg",
    "/images/1.jpg",
    "/images/3.jpg",
    "/images/4.jpg",
    "/images/5.jpg",
    "/images/6.jpg",
    "/images/7.jpg",
    "/images/8.jpg",
    "/images/10.jpg",
    "/images/11.jpg",
    "/images/12.jpg",
    "/images/13.jpg",
    "/images/14.jpg",
    "/images/15.jpg",
];

const getMockParticipantAvatars = (seed: number, count: number): string[] => {
    let state = seed || 1;
    const avatars = [...mockParticipantAvatarPool];

    const nextRandom = () => {
        state = (state * 1664525 + 1013904223) % 4294967296;
        return state / 4294967296;
    };

    for (let index = avatars.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(nextRandom() * (index + 1));
        [avatars[index], avatars[swapIndex]] = [avatars[swapIndex], avatars[index]];
    }

    return avatars.slice(0, count);
};

const Participants = ({ event }: Props) => {
    // Расчет свободных мест
    const participantsCount = event.profiles ? event.profiles.length : 0;
    const freePlaces = Math.max(0, event.places - participantsCount);
    const shouldShowMockParticipants = Boolean(event.is_card_closed) && participantsCount === 0;
    const maxPlaces = event.places > 0 ? event.places : 10;
    const mockParticipantAvatars = getMockParticipantAvatars(event.id, 4);
    const mockAdditionalParticipants = Math.max(0, maxPlaces - mockParticipantAvatars.length);

    // Последние N участников
    const lastParticipants = event.profiles ? event.profiles.slice(0, 4) : [];
    const additionalParticipants = participantsCount > 4 ? participantsCount - 4 : 0;
    const freePlacesWord = pluralizeRu(freePlaces, "место", "места", "мест");

    const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        const target = e.currentTarget as HTMLImageElement;
        target.src = defaultAvatar;
    };
    
    const isFinished = event.is_finished;

    return (
        <div className={style.container}>
            {(participantsCount > 0 || shouldShowMockParticipants) && (
                <div className={style.participants}>
                    <div className={style.avatars}>
                        {shouldShowMockParticipants ? (
                            <>
                                {mockParticipantAvatars.map((avatar) => (
                                    <div
                                        key={avatar}
                                        className={style.avatarWrapper}
                                        title="Участник"
                                    >
                                        <img
                                            src={avatar}
                                            alt="Аватар"
                                            className={style.avatar}
                                            onError={handleImageError}
                                        />
                                    </div>
                                ))}

                                {mockAdditionalParticipants > 0 && (
                                    <div className={style.moreParticipants}>
                                        +{mockAdditionalParticipants}
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                {lastParticipants.map((profile, index) => (
                                    <div
                                        key={profile.id || index}
                                        className={style.avatarWrapper}
                                        title={profile.name || 'Участник'}
                                    >
                                        <img
                                            src={profile.photos?.[0]?.url || defaultAvatar}
                                            alt="Аватар"
                                            className={style.avatar}
                                            onError={handleImageError}
                                        />
                                    </div>
                                ))}

                                {additionalParticipants > 0 && (
                                    <div className={style.moreParticipants}>
                                        +{additionalParticipants}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            )}

            {!isFinished && (
                <div className={style.freePlaces}>
                    {freePlaces > 0 && (<>Осталось  <span>{freePlaces}</span> {freePlacesWord}</>)}
                    {freePlaces < 1 && (<>Мест нет</>)}
                </div>
            )}
        </div>
    );
}
export default Participants;
